import * as React from "react";

const MusicNote = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.2754 20.0684" {...props}>
      <g>
        <rect height={20.0684} opacity={0} width={12.2754} x={0} y={0} />
        <path d="M11.9141 4.89258L11.9141 1.2207C11.9141 0.703125 11.4941 0.371094 10.9961 0.46875L5.97656 1.5625C5.35156 1.69922 5.00977 2.04102 5.00977 2.58789L5.0293 13.4473C5.07812 13.9258 4.85352 14.2383 4.42383 14.3262L2.87109 14.6484C0.917969 15.0586 0 16.0547 0 17.5293C0 19.0234 1.15234 20.0684 2.77344 20.0684C4.20898 20.0684 6.35742 19.0137 6.35742 16.1719L6.35742 7.23633C6.35742 6.71875 6.45508 6.61133 6.91406 6.51367L11.377 5.53711C11.709 5.46875 11.9141 5.21484 11.9141 4.89258Z" />
      </g>
    </svg>
  );
};

export default MusicNote;
